import React from 'react';
import { createRoot } from 'react-dom/client';
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import ExtraPickupFormApp from "@apps/Shared/Blocks/ExtraPickupFormBlock/ExtraPickupFormApp";

const container = document.getElementById('js-extra-pickup-form')!;
const root = createRoot(container);
const queryClient = new QueryClient();

root.render(
    <QueryClientProvider client={queryClient}>
        <ExtraPickupFormApp />
    </QueryClientProvider>
);